export default __webpack_public_path__ + "static/media/empty_state_swap.bca959c0.svg";